import { BodyCell } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { DataConnections } from '~src/connectivity/resources/DataConnections';

import { IDataConnectionInfo } from '../../../ts/models/IDataConnectionInfo';
import { StyledCellFormatter } from './StyledCellWrapper';

// These are (mostly) a direct copy of common/DataGridCells
// Here they just use the classes from widgets-datagrid

export namespace DataConnectionDataGridCells {
  export function AuthenticationCellFormatter(): React.StatelessComponent<BodyCell.Props> {
    return StyledCellFormatter(
      (props: BodyCell.Props): React.ReactElement<any> => {
        const connection = props.row.data as IDataConnectionInfo;
        const text = DataConnections.getDisplayAuthentication(connection);

        // Tableau server connections return empty string
        return React.createElement('span', {}, text);
      }
    );
  }

  export function UsernameCellFormatter(): React.StatelessComponent<BodyCell.Props> {
    return StyledCellFormatter(
      (props: BodyCell.Props): React.ReactElement<any> => {
        const connection = props.row.data as IDataConnectionInfo;
        const text = DataConnections.getDisplayUsername(connection);

        // File, Tableau Server, and Web Data connections return empty string
        return React.createElement('span', {}, text);
      }
    );
  }
}
